import { useLocalStorage } from '@rehooks/local-storage';
import { getVisibleColumnsKey } from '../../utils';
export var useVisibleColumns = function (listID) {
    var storageKey = getVisibleColumnsKey(listID);
    var _a = useLocalStorage(storageKey), _b = _a[0], cachedColumns = _b === void 0 ? [] : _b, setCachedColumns = _a[1];
    var setDefaultVisibleColumns = function (defaultColumns) {
        if (defaultColumns === void 0) { defaultColumns = []; }
        setCachedColumns(cachedColumns !== null && cachedColumns !== void 0 ? cachedColumns : defaultColumns);
    };
    var handleColumnsChange = function (_a) {
        var values = _a.values;
        // There is always should be at least one selected column
        if (values.length === 0) {
            return;
        }
        setCachedColumns(values);
    };
    return {
        setDefaultVisibleColumns: setDefaultVisibleColumns,
        handleColumnsChange: handleColumnsChange,
        visibleColumns: cachedColumns
    };
};
